import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Prohibit } from '@phosphor-icons/react';

/*
 * Single source for status badges. Geometry lives in
 * src/assets/css/components/badge.css so the `.badge badge-*` class users and
 * this component can never drift apart again.
 *
 * BANNED carries a glyph as well as a hue because it is the only badge whose
 * meaning is punitive and the only one a colour-blind operator must not miss.
 */
const TONE = {
  SUCCESS: 'badge-success',
  APPROVED: 'badge-success',
  ACTIVE: 'badge-success',
  PAID: 'badge-success',
  SENT: 'badge-success',
  PROCESSED: 'badge-success',

  PENDING: 'badge-warning',
  UNBAN: 'badge-warning',
  'NO REQUIREMENTS PASSED': 'badge-warning',

  PROCESSING: 'badge-info',

  INACTIVE: 'badge-danger',
  REJECTED: 'badge-danger',
  FAILED: 'badge-danger',
  BAN: 'badge-danger',
  BANNED: 'badge-danger',

  DRAFT: 'badge-neutral',
  EXPIRED: 'badge-neutral',
};

const GLYPH_STATES = ['BAN', 'BANNED'];

const Badges = ({ colors, status, children, containerClassName }) => {
  const key = String(status || '').toUpperCase();
  const tone = colors[key] || TONE[key] || 'badge-neutral';
  return (
    <span className={cn('badge', tone, containerClassName)}>
      {GLYPH_STATES.includes(key) ? (
        <Prohibit size={11} weight="bold" aria-hidden="true" />
      ) : (
        <span className="badge-dot" aria-hidden="true" />
      )}
      {!children?.length ? status : children}
    </span>
  );
};

Badges.defaultProps = {
  colors: {},
  status: 'APPROVED',
  containerClassName: '',
  children: '',
};

Badges.propTypes = {
  colors: PropTypes.instanceOf(Object),
  containerClassName: PropTypes.string,
  status: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
};

export default Badges;
